export default __webpack_public_path__ + "static/media/IOT.538c1e05584a1942b3ecb2f3a4ca6c9a.webp";